import { createContext, useContext, useState, ReactNode } from "react";

interface StudentAIData {
  id?: string;
  name: string;
  goal?: string;
  injuries?: string;
  medications?: string;
  observations?: string;
  modalities?: string[];
  anamnesis?: string;
  platformData?: string;
}

interface StudentAIContextValue {
  studentData: StudentAIData | null;
  setStudentData: (data: StudentAIData | null) => void;
}

const Ctx = createContext<StudentAIContextValue>({ studentData: null, setStudentData: () => {} });

export function StudentAIProvider({ children }: { children: ReactNode }) {
  const [studentData, setStudentData] = useState<StudentAIData | null>(null);
  return <Ctx.Provider value={{ studentData, setStudentData }}>{children}</Ctx.Provider>;
}

export function useStudentAI() {
  return useContext(Ctx);
}
